import React from 'react';
import Screener from '../components/Screener';

const ScreenerPage: React.FC = () => {
  return (
    <div className="portfolio-page">
      <div className="portfolio-header" style={{ marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Market Screener</h1>
        <div className="portfolio-stats" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          backgroundColor: '#f8fafc',
          padding: '1.5rem',
          borderRadius: '0.5rem'
        }}>
          <div className="stat">
            <label style={{ color: '#64748b', marginBottom: '0.5rem', display: 'block' }}>Description</label>
            <span style={{ display: 'block', lineHeight: '1.5' }}>
              Filter and discover stocks, ETFs, and funds based on various criteria including market cap, P/E ratio, and more.
            </span>
          </div>
          <div className="stat">
            <label style={{ color: '#64748b', marginBottom: '0.5rem', display: 'block' }}>Features</label>
            <span style={{ display: 'block', lineHeight: '1.5' }}>
              • Advanced filtering options<br />
              • Real-time market data<br />
              • Performance metrics
            </span>
          </div>
        </div>
      </div>
      <Screener />
    </div>
  );
};

export default ScreenerPage;
